import React, { useContext, useEffect, useState } from 'react'
import './admin.css'
import { host, token } from '../host';
import axios from 'axios'
import StickyHeadTable from '../table/UniversalTable';
import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Paper, Select, TextField } from '@mui/material';
import { toast } from 'react-hot-toast';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LoadingIndicator from '../LoadingIndicator';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { UserContext } from '../context/UserContext';

const columns = [
    { id: 'action', label: 'Оператция', minWidth: 100 },
    { id: 'media', label: 'Номер акта', minWidth: 50 },
    { id: 'user', label: 'Email пользователя', minWidth: 200 },
    { id: 'createdAt', label: 'Время', minWidth: 200 }
];

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const History = () => {
    const user = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [acts, setActs] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true)
        axios.get(`${host}/api/v1/history`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                setActs(response.data);
            })
            .catch((error) => {
                console.error("Ошибка при запросе:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [location.pathname]);

    return (
        <LoadingIndicator loading={loading}>
            <div className="container">
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'left',
                    gap: '20px',
                    marginTop: '20px',
                    marginBottom: '20px',
                }}>
                    {user.user.status !== 'AUDITOR' &&
                        <h1 onClick={() => navigate('/users')} style={{
                            fontSize: '24px',
                            cursor: 'pointer',
                            fontWeight: '400',
                            borderBottom: location.pathname === '/users' ? '2px solid' : 'none',
                        }}>Пользователи</h1>
                    }
                    <h1 onClick={() => navigate('/acts')} style={{
                        fontSize: '24px',
                        cursor: 'pointer',
                        fontWeight: '400',
                        borderBottom: location.pathname === '/acts' ? '2px solid' : 'none',
                    }}>Акты</h1>
                    <h1 onClick={() => navigate('/new/acts')} style={{
                        fontSize: '24px',
                        cursor: 'pointer',
                        fontWeight: '400',
                        borderBottom: location.pathname === '/new/acts' ? '2px solid' : 'none',
                    }}>Внутренний акты</h1>
                    <h1 onClick={() => navigate('/history')} style={{
                        fontSize: '24px',
                        cursor: 'pointer',
                        fontWeight: '400',
                        borderBottom: location.pathname === '/history' ? '2px solid' : 'none',
                    }}>История изменений</h1>
                </Box>
                <Box className="title__btn" sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '20px',
                    marginTop: '20px',
                    marginBottom: '20px',
                }}>
                    <div className="title" ><span>История изменений</span></div>
                </Box>
                <StickyHeadTable
                    rows={acts}
                    columns={columns}
                />
            </div>
        </LoadingIndicator>
    )
}

export default History
